import lazyLoading from "./lazyLoading";

export default {
  name: "import",
  path: "/import",
  component: lazyLoading("excel/Import"),
  meta: {
    default: false,
    expanded: false,
    title: "Import",
    class: "primary",
    show: false,
    iconClass: "glyphicon glyphicon-import",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/excel.js